import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { ContinentScene } from './scenes/ContinentScene';
import { PokedexScene } from './scenes/PokedexScene';
import { RiddleScene } from './scenes/RiddleScene';
import { CeremonyScene } from './scenes/CeremonyScene';
import { MilestoneScene } from './scenes/MilestoneScene';

// Canvas is 1400×1380 native on desktop (the tile renderer requires this
// width for the map at full scale) and 820×1500 on portrait phones (tall
// column for narrow viewports). Phaser FIT-scales the canvas to whatever
// viewport the browser presents; on a 1366×768 laptop that's ~55% scale,
// so font sizes throughout the scenes are tuned 1.4× larger than they
// would otherwise be to stay legible at that scale.
const portraitMobile =
  typeof window !== 'undefined' &&
  window.innerWidth < 820 &&
  window.innerHeight > window.innerWidth;

const NATIVE_WIDTH = portraitMobile ? 820 : 1400;
const NATIVE_HEIGHT = portraitMobile ? 1500 : 1380;

new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'app',
  // preserveDrawingBuffer ensures the WebGL canvas can be captured by
  // screenshots / dev tooling (the default destroys the framebuffer between
  // frames, leaving captures blank).
  render: { preserveDrawingBuffer: true },
  width: NATIVE_WIDTH,
  height: NATIVE_HEIGHT,
  pixelArt: true,
  scale: {
    mode: Phaser.Scale.FIT,
    // No autoCenter — let the parent #app's flexbox centre the canvas.
    // Doubling them up was off-setting the canvas by ~120px on most viewports.
    autoCenter: Phaser.Scale.NO_CENTER,
  },
  backgroundColor: '#0d0a08',
  scene: [BootScene, ContinentScene, PokedexScene, RiddleScene, MilestoneScene, CeremonyScene],
});

// Canvas dimensions are picked once at boot from the viewport orientation.
// Reload on rotation so portrait↔landscape gets the right canvas + reflow.
if (typeof window !== 'undefined') {
  let lastPortrait = window.innerHeight > window.innerWidth;
  window.addEventListener('resize', () => {
    const nowPortrait = window.innerHeight > window.innerWidth;
    if (nowPortrait !== lastPortrait) {
      lastPortrait = nowPortrait;
      window.location.reload();
    }
  });
}
